import React, { useContext, useEffect } from "react";
import {
	Route,
	Routes,
	Navigate,
	Outlet as RouterOutlet,
	useLocation,
	useNavigate,
} from "react-router-dom";
import AdminAcademyAllSeminars from "./academy/admin/AllSeminars";
import AllVideoProgress from "./academy/admin/AllVideoProgress";
import AdminAcademyEditSeminar from "./academy/admin/EditSeminar";
import AdminEditCompany from "./components-dev-admin/manage-company/EditCompany";
import UserList from "./components-dev-admin/UserList";
import MyProfile from "./components-user/EditProfile";
// Onboarding
import Onboarding from "./components-user/registration/AccountSetup";
import AccountSetup from "./components-user/registration/AccountSetup";
import Navigation from "./Navigation";
import NavigationAdmin from "./NavigationAdmin";
import AdminCompanies from "./pages-dev-admin/Companies";
import AdminCompanyJobs from "./pages-dev-admin/company-data/jobs/AllJobs";
import AdminCompanyEditJob from "./pages-dev-admin/company-data/jobs/EditJob";
import AdminCompanyProducts from "./pages-dev-admin/company-data/products/AllProducts";
import AllActions from "./pages-dev-admin/event-management/AllActions";
import AdminAllEvents from "./pages-dev-admin/event-management/AllEvents";
// Lecture registration imports removed - using new modular system
import AllLectures from "./pages-dev-admin/event-management/AllLectures";
import AdminAllTickets from "./pages-dev-admin/event-management/AllTickets";
import AdminBookedBooths from "./pages-dev-admin/event-management/BookedBooths";
import AdminBookedEquipment from "./pages-dev-admin/event-management/BookedEquipment";
import AdminCustomBoothRequests from "./pages-dev-admin/event-management/CustomBoothRequests";
import AdminEventCarpets from "./pages-dev-admin/event-management/EventCarpets";
import AdminEditEvent from "./pages-dev-admin/event-management/edit-event/index";
import AdminInvitationCodes from "./pages-dev-admin/event-management/InvitationCodes";
import PrintTicket from "./pages-dev-admin/event-management/printTicket/PrintTicket";
import AdminIndustries from "./pages-dev-admin/industries/AdminIndustries";
import AdminEditIndustries from "./pages-dev-admin/industries/EditIndustry";
import EditLectureAdmin from "./pages-dev-admin/lectures/EditLecture";
import AdminLectureScheduling from "./pages-dev-admin/lectures/Scheduling";
import AdminMediaSeriesList from "./pages-dev-admin/mediathek/MediaSeriesList";
import AdminEditMediaSeries from "./pages-dev-admin/mediathek/EditMediaSeries";
import AdminMediaItemList from "./pages-dev-admin/mediathek/MediaItemList";
import AdminEditMediaItem from "./pages-dev-admin/mediathek/EditMediaItem";
import AdminAllNews from "./pages-dev-admin/news/AllNews";
import AdminEditNews from "./pages-dev-admin/news/EditNews";
import AdminAllOrders from "./pages-dev-admin/orders/AllOrders";
import AdminCreateOrder from "./pages-dev-admin/orders/CreateOrder";
import AdminPlatformUsers from "./pages-dev-admin/PlatformUsers";
import AdminAllProducts from "./pages-dev-admin/products/AllProducts";
import AdminCreateProduct from "./pages-dev-admin/products/EditProduct";
import TEMPCompaniesAttendingEvent from "./pages-dev-admin/TEMP/CompaniesAttendingEvent";
import AdminCreateCompany from "./pages-dev-admin/TEMP/CreateCompany";
import AdminCreateUser from "./pages-dev-admin/TEMP/CreateUser";
import TEMPPromotionTimes from "./pages-dev-admin/TEMP/PromotionsTimes";
import AdminCognitoUsers from "./pages-dev-admin/users/CognitoUsers";
// Admin Pages
import AdminEditUser from "./pages-dev-admin/users/User";
import Companies from "./pages-user/Companies";
import Company from "./pages-user/CompanyDetail";
import Chat from "./pages-user/chat/Chat";
// User Pages
import DashboardUserAdmin from "./pages-user/Dashboard-User-Admin";
import Actions from "./pages-user/event-management/actions/AllActions";
import RegisterAction from "./pages-user/event-management/actions/RegisterLecture";
import EditBooth from "./pages-user/event-management/booth/EditBooth";
import EventGuests from "./pages-user/event-management/EventGuests";
import Lectures from "./pages-user/event-management/lectures/AllLectures";
import AllBookings from "./pages-user/event-management/tickets/AllBookings";
// User Tickets
import BookTicket from "./pages-user/event-management/tickets/BookTicket";
import MyCompanyBillingSettings from "./pages-user/manage-company/BillingSettings";
import CompanyBookings from "./pages-user/manage-company/CompanyBookings";
import MyCompanyDepartments from "./pages-user/manage-company/Departments";
import MyCompanyEmployees from "./pages-user/manage-company/Employees";
import MyEmployeeProfile from "./pages-user/manage-company/MyEmployeeProfile";
import MyCompanyProfile from "./pages-user/manage-company/Profile";
import RequestAffiliation from "./pages-user/manage-company/RequestAffiliation";
import MyCompanyRequests from "./pages-user/manage-company/Requests";
// News
import AllNews from "./pages-user/news/AllNews";
import CreateNews from "./pages-user/news/CreateNews";
// Products
import AllProducts from "./pages-user/products/AllProducts";
import CreateProduct from "./pages-user/products/CreateProduct";
import AllRecruitingLectures from "./pages-user/recruiting/AllRecruitingLectures";
import CreateJobListing from "./pages-user/recruiting/CreateJobListing";
import RegisterRecruitingLecture from "./pages-user/recruiting/CreateRecruitingLecture";
import RedirectDashboardOnboarding from "./utils/redirectDashboardOnboarding";
import ScrollToTop from "./utils/scrollTop";
import { BreadcrumbProvider } from "./components/breadcrumb/BreadcrumbContext";
import GlobalBreadcrumb from "./components/breadcrumb/GlobalBreadcrumb";
//Shop

import AllCourses from "./academy/admin/AllCourses";
import EditCourse from "./academy/admin/EditCourse";
import UserCourseProgress from "./academy/admin/UserCourseProgress";
// Adacemy
import AllBasicCourses from "./academy/basics/AllBasicCourses";
import AllLecturesList from "./academy/basics/AllLecturesList";
import CourseDetail from "./academy/basics/CourseDetail";
// Insight
import LectureVideo from "./academy/basics/LectureVideo";
import CompanyRouteWrapper from "./components-user/CompanyRouteWrapper";
import RegisterLectureMUI from "./components-user/event-management/lecture-registration/Index";
import LectureRegistrationTestWrapper from "./components-user/event-management/lecture-registration/LectureRegistrationTestWrapper";
import AllDiscounts from "./pages-dev-admin/discounts/AllDiscounts";
import EditDiscount from "./pages-dev-admin/discounts/EditDiscount";
import AdminStockReservations from "./pages-dev-admin/products/stockreservation/StockReservations";
import AdminAllBooths from "./pages-dev-admin/booths/AllBooths";
import AdminEditBooth from "./pages-dev-admin/booths/EditBooth";
import AdminChatbot from "./pages-dev-admin/chatbot/AdminChatbot";
import AdminSystemDocumentSettings from "./pages-dev-admin/system/SystemDocumentSettings";
import AdminEditSystemDocumentSettings from "./pages-dev-admin/system/EditSystemDocumentSettings";
// Temp
import SelectBooth from "./pages-user/event-management/booking/SelectBooth";
import SelectBoothMap from "./pages-user/event-management/booking/interactive/SelectBoothMap";
import AllEventLectures from "./pages-user/lectures/AllEventLectures";
import MyLectures from "./pages-user/lectures/MyLectures";
// Checkout
import Checkout from "./pages-user/order/checkout/Checkout";
import OrderThankYou from "./pages-user/order/checkout/ThankYou";
import Shop from "./pages-user/shop/Shop";

/** Redirects non-admin users to the dashboard, waits for admin check to complete */
function AdminGuard({ isAdmin, isAdminLoaded }) {
	if (!isAdminLoaded) return <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
	if (!isAdmin) return <Navigate to="/" replace />;
	return <RouterOutlet />;
}

/** Allows Admins OR HDLectureManager users through to scoped admin routes */
function HDLectureManagerGuard({ isAdmin, isHDLectureManager, isAdminLoaded }) {
	if (!isAdminLoaded) return <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
	if (!isAdmin && !isHDLectureManager) return <Navigate to="/" replace />;
	return <RouterOutlet />;
}


const FourtOFour = () => <h1 className="text-center">404</h1>;

function AppRoutes(props) {
	return (
		<BreadcrumbProvider>
			{!props.isInitialized ? (
				<h1>Loading...</h1>
			) : (
				<>
					{props.isAdmin && !props.adminAsUser ? (
						<NavigationAdmin
							signOut={props.signOut}
							isAdmin={props.isAdmin}
							adminAsUser={props.adminAsUser}
							setAdminAsUser={props.setAdminAsUser}
							setDesktopFullscreen={props.setDesktopFullscreen}
						/>
					) : (
						<Navigation
							signOut={props.signOut}
							isAdmin={props.isAdmin}
							setAdminAsUser={props.setAdminAsUser}
						/>
					)}
					{/* <OnboardingChecker /> */}
					<ScrollToTop />
					<GlobalBreadcrumb />
					{/* <RedirectDashboardOnboarding user={props.user} /> */}
					<Routes>
						{/* Allgemeine Routen */}
						<Route exact path="/" element={<DashboardUserAdmin />} />
						<Route exact path="/accountsetup" element={<AccountSetup />} />
						<Route exact path="/users" element={<UserList />} />
						<Route
							exact
							path="/companies-attending-event"
							element={<TEMPCompaniesAttendingEvent />}
						/>
						<Route exact path="/companies" element={<Companies />} />
						<Route exact path="/company/:companyid" element={<Company />} />
						<Route
							exact
							path="/event-lectures"
							element={<AllEventLectures />}
						/>
						<Route exact path="/my-lectures" element={<MyLectures />} />
						<Route exact path="/chat" element={<Chat />} />
						<Route exact path="/shop" element={<Shop />} />

						{/* Admin-spezifische Routen */}
						<Route path="/admin" element={<AdminGuard isAdmin={props.isAdmin} isAdminLoaded={props.isAdminLoaded} />}>
							<Route index element={null} />
							<Route path="users" element={<AdminPlatformUsers />} />
							<Route
								exact
								path="cognito-users"
								element={<AdminCognitoUsers />}
							/>
							<Route path="user/:userid" element={<AdminEditUser />} />
							<Route path="create-user" element={<AdminCreateUser />} />
							<Route path="companies" element={<AdminCompanies />} />
							<Route path="create-company" element={<AdminCreateCompany />} />
							<Route path="company/:companyid" element={<AdminEditCompany />} />
							<Route path="tickets" element={<AdminAllTickets />} />
							<Route path="orders" element={<AdminAllOrders />} />
							<Route path="order/create" element={<AdminCreateOrder />} />
							<Route path="products" element={<AdminAllProducts />} />
							<Route
								path="stockreservations"
								element={<AdminStockReservations />}
							/>
							<Route
								path="product/:productId"
								element={<AdminCreateProduct />}
							/>
							<Route path="product/create" element={<AdminCreateProduct />} />
							{/* Booth maintenance (booths stay Products of type event_booth/event_space) */}
							<Route path="booths" element={<AdminAllBooths />} />
							<Route path="booth/create" element={<AdminEditBooth />} />
							<Route path="booth/:productId" element={<AdminEditBooth />} />

							<Route path="discounts" element={<AllDiscounts />} />
							<Route path="discount/:discountId" element={<EditDiscount />} />

							<Route path="printticket" element={<PrintTicket />} />
							<Route path="news" element={<AdminAllNews />} />
							<Route
								path="news/:companyId/:newsId"
								element={<AdminEditNews />}
							/>
							<Route path="news/create" element={<AdminEditNews />} />
							<Route
								path="company-products"
								element={<AdminCompanyProducts />}
							/>
							<Route path="company-product/:companyId/product/:productId" element={<CreateProduct />} />
							<Route path="company-jobs" element={<AdminCompanyJobs />} />
							<Route
								path="company-job/:jobId"
								element={<AdminCompanyEditJob />}
							/>
							<Route path="promotiontimes" element={<TEMPPromotionTimes />} />
							<Route path="video-progress" element={<AllVideoProgress />} />
							<Route path="event/create" element={<AdminEditEvent />} />
							<Route
								path="event/invitation-codes"
								element={<AdminInvitationCodes />}
							/>
							<Route path="event-carpets" element={<AdminEventCarpets />} />
							<Route path="booked-booths" element={<AdminBookedBooths />} />
							<Route
								path="custom-booth-requests"
								element={<AdminCustomBoothRequests />}
							/>
							<Route
								path="booked-equipment"
								element={<AdminBookedEquipment />}
							/>
							{/* Insight Admin */}
							<Route path="insight/courses" element={<AllCourses />} />
							<Route path="insight/course/create" element={<EditCourse />} />
							<Route path="insight/course/:courseId" element={<EditCourse />} />
							<Route
								path="insight/user-course-progress/:userId"
								element={<UserCourseProgress />}
							/>
							{/* Academy Admin */}
							<Route
								path="academy/seminars"
								element={<AdminAcademyAllSeminars />}
							/>
							<Route
								path="academy/seminar/:seminarId"
								element={<AdminAcademyEditSeminar />}
							/>
							<Route
								path="academy/seminar/create"
								element={<AdminAcademyEditSeminar />}
							/>
							{/* Industries */}
							<Route path="industries" element={<AdminIndustries />} />
							<Route
								path="industry/:industryId"
								element={<AdminEditIndustries />}
							/>
							<Route path="industry/create" element={<AdminEditIndustries />} />
							{/* Mediathek (media library) */}
							<Route path="mediathek" element={<AdminMediaSeriesList />} />
							<Route
								path="mediathek/series/create"
								element={<AdminEditMediaSeries />}
							/>
							<Route
								path="mediathek/series/:seriesId"
								element={<AdminEditMediaSeries />}
							/>
							<Route
								path="mediathek/series/:seriesId/items/create"
								element={<AdminEditMediaItem />}
							/>
							<Route path="mediathek/items" element={<AdminMediaItemList />} />
							<Route
								path="mediathek/items/:itemId"
								element={<AdminEditMediaItem />}
							/>
							{/* AI Chatbot */}
							<Route path="chatbot" element={<AdminChatbot />} />
							{/* System Settings */}
							<Route
								path="system/document-settings"
								element={<AdminSystemDocumentSettings />}
							/>
							<Route
								path="system/document-settings/create"
								element={<AdminEditSystemDocumentSettings />}
							/>
							<Route
								path="system/document-settings/:documentType/:industryId"
								element={<AdminEditSystemDocumentSettings />}
							/>
						</Route>

						{/* HDLectureManager-scoped admin routes (also accessible for full admins) */}
						<Route path="/admin" element={<HDLectureManagerGuard isAdmin={props.isAdmin} isHDLectureManager={props.isHDLectureManager} isAdminLoaded={props.isAdminLoaded} />}>
							<Route path="events" element={<AdminAllEvents />} />
							<Route path="event/:eventId" element={<AdminEditEvent />} />
							<Route path="lectures" element={<AllLectures />} />
							<Route path="lecture_scheduling" element={<AdminLectureScheduling />} />
							<Route path="lecture/:companyid/:lectureid" element={<EditLectureAdmin />} />
						</Route>

						{/* Benutzer-spezifische Routen */}
						<Route
							path="/mycompany/:companyid"
							element={<CompanyRouteWrapper />}
						>
							<Route index element={<MyCompanyProfile />} />
							<Route path="requests" element={<MyCompanyRequests />} />
							<Route path="profile" element={<MyCompanyProfile />} />
							<Route path="employees" element={<MyCompanyEmployees />} />
							<Route path="departments" element={<MyCompanyDepartments />} />
							<Route path="billing" element={<MyCompanyBillingSettings />} />
							<Route
								path="myemployeeprofile/:employeeid"
								element={<MyEmployeeProfile />}
							/>
							<Route path="lectures" element={<Lectures />} />

							{/* Lecture registration now handled via modal in AllLectures component */}
							<Route
								path="register-lecture-mui"
								element={<RegisterLectureMUI />}
							/>
							<Route
								path="register-lecture-test"
								element={<LectureRegistrationTestWrapper />}
							/>
							<Route path="actions" element={<Actions />} />
							<Route path="register-action" element={<RegisterAction />} />
							<Route
								path="register-action/:actionid"
								element={<RegisterAction />}
							/>
							<Route
								path="recruiting-lectures"
								element={<AllRecruitingLectures />}
							/>
							<Route
								path="register-recruiting-lecture"
								element={<RegisterRecruitingLecture />}
							/>
							<Route
								path="register-recruiting-lecture/:lectureid"
								element={<RegisterRecruitingLecture />}
							/>
							<Route path="news" element={<AllNews />} />
							<Route path="news/create" element={<CreateNews />} />
							<Route path="news/:newsid" element={<CreateNews />} />
							<Route path="job-listing/create" element={<CreateJobListing />} />
							<Route
								path="job-listing/:newsid"
								element={<CreateJobListing />}
							/>
							<Route path="products" element={<AllProducts />} />
							<Route path="product/create" element={<CreateProduct />} />
							<Route path="product/:productid" element={<CreateProduct />} />
							<Route path="select-booth/:eventId" element={<SelectBooth />} />
							{/* Test path: interactive hall-plan booth booking (replaces select-booth after cut-over) */}
							<Route path="select-booth-map/:eventId" element={<SelectBoothMap />} />
							<Route path="event-guests" element={<EventGuests />} />
							<Route path="company-bookings" element={<CompanyBookings />} />
							<Route path="edit-booth/:boothId" element={<EditBooth />} />
							{/* Weitere Benutzer-Routen hier einfügen */}
						</Route>
						{/* Lecture Media */}
						<Route path="/lecture/:lectureId" element={<LectureVideo />} />
						{/* Insight */}
						<Route
							path="/insight/lecture-video/:lectureId"
							element={<LectureVideo />}
						/>
						<Route
							path="/insight/lectureVideos"
							element={<AllLecturesList />}
						/>

						{/* Academy */}
						<Route path="/academy/basics" element={<AllBasicCourses />} />
						<Route
							path="/academy/basics/course/:courseId"
							element={<CourseDetail />}
						/>
						<Route
							path="/academy/basics/lecture/:lectureId"
							element={<LectureVideo />}
						/>

						{/* Weitere allgemeine Routen */}
						<Route path="/onboarding" element={<Onboarding />} />
						<Route path="/myprofile" element={<MyProfile />} />
						<Route
							path="/company/:companyid/request-affiliation"
							element={<RequestAffiliation />}
						/>

						{/* Tickets */}
						<Route path="/book-ticket" element={<BookTicket />} />
						<Route path="/bookings" element={<AllBookings isAdmin={props.isAdmin} />} />

						{/* Checkout */}
						<Route path="/checkout" element={<Checkout />} />
						<Route
							path="/order/confirmation/:orderId"
							element={<OrderThankYou />}
						/>

						{/* Fallback für nicht gefundene Seiten */}
						<Route path="*" element={<FourtOFour />} />
					</Routes>
				</>
			)}
		</BreadcrumbProvider>
	);
}
export default AppRoutes;
